import React, { useEffect, useRef, useState } from 'react';
// import image from '../../Assets/images/HomePage/BANNER.webp';
// import { default as image1, default as image2 } from '../../Assets/images/HomePage/homeiPadNewBanner.webp';
import image1 from '../../Assets/images/commonImages/ipadBanner.webp';
import image2 from '../../Assets/images/commonImages/ipadBanner.webp';
import image from '../../Assets/images/commonImages/dektopBanner.webp';
import mobileImg from '../../Assets/images/HomePage/homemWeb.webp';
import Footer from '../../components/Footer/Footer';
import PostHeader from '../../components/Header/PostHeader';
import SimpleHeader from '../../components/Header/simpleHeader';
import './AstoundHome.scss';
import _ from 'lodash';
// import image3 from '../../Assets/images/HomePage/homemWebNewBanner.svg';
import { CircularProgress } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import failedIcon from '../../Assets/images/Activation/failed.svg';
import successIcon from '../../Assets/images/Activation/success.svg';
import redSimIcon from '../../Assets/images/HomePage/activationFailedIcon.svg';
import portingLoaderIcon from '../../Assets/images/HomePage/portLoaderIcon.svg';
import addDataIcon from '../../Assets/images/HomePage/addData.svg';
import decrementIcon from '../../Assets/images/HomePage/dec.svg';
import incrementIcon from '../../Assets/images/HomePage/inc.svg';
import refreshIcon from '../../Assets/images/HomePage/refresh.svg';
import refreshIcon1 from '../../Assets/images/PostActivation/Account/2XD.gif';
import backArrow from '../../Assets/images/PostActivation/Account/backArrow.svg';
import contactUs from '../../Assets/images/ContactUs/contactus.svg';
import upArrow from '../../Assets/images/PostActivation/Account/CLOSE_ICON.svg';
import downArrow from '../../Assets/images/PostActivation/Account/DROP_ICON.svg';
import Skeleton from 'react-loading-skeleton';
import AddLineSuccess from '../../components/AddLineSuccess/AddLineSuccess';
import AddLineSummary from '../../components/AddLineSummary/addLineSummary';
import Button from '../../components/Button/Button';
import OneTimeCharge from '../../components/OneTimeChargeSim/OneTimeCharge';
import TextField from '../../components/Textfield/TextField';
import VerifyDevice from '../../components/VerifyDevice/VerifyDevice';
import { altText } from '../../global/altText';
import { globalVal } from '../../global/globalvalues';
import { seoData } from '../../global/seoData';
import { activationPage } from '../../global/texts/postActivation/activation';
import {
    activationStatus,
    dataUsage as dataUsageOverall,
    currentDataUsage,
    getAppData,
} from '../../store/Activation/actions';
import { userPlans } from '../../store/Billing/actions';
import {
    GetCustomer,
    GetOrderByCustomerId,
    // ---- HSD Changes ------
    Coupon,
} from '../../store/Checkout/actions';
import {  activationPrecheck, customerGroup, topUpCustomer, topUpCustomerStatus } from '../../store/PostActivation/actions';
import { toNumber } from 'lodash';
// import { textTruncate } from '../../global/commonFunctions/TextTruncate';
import phone from '../../Assets/images/Activation/Shape.svg';
import icon from '../../Assets/images/PostActivation/Home/icon.svg';
import throttleIcon from '../../Assets/images/PostActivation/Home/speed.svg';
import { isHSDEnabled } from '../../config';
import GenericError from '../../components/GenericError/GenericError';
import lightInfoIcon from '../../Assets/images/commonImages/lightInfoIcon.svg';
import { setTimeout } from 'timers';
import { bytesToSize } from '../../global/commonFunctions/ConverDataFromBytes';
import MessageComponent from '../../components/MessageComponent/MessageComponent';
// import { pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';
import moment from 'moment';
import TagManager from 'react-gtm-module';
import { reachPlan, trackOrderGet } from '../../store/TrackOrder/actions';
import { textTruncate } from '../../global/commonFunctions/TextTruncate';
import { returnName } from '../../global/commonFunctions/getUserName';
import editIcon from '../../Assets/images/PostActivation/Home/editIcon.svg';
import AddLineUserDetails from '../../components/AddLineUserDetails/AddLineUserDetails';

type initialProps = {
    history: any;
};

const AstoundHome = (props: initialProps) => {
    const [loader, setLoader] = useState(true);
    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const [isBuyDataClicked, setIsBuyDataClicked] = useState(false);
    const [user, setUser] = useState<any>(null);
    const [isAddData, setIsAddData] = useState(false);
    const [isAddDataJourney, setIsAddDataJourney] = useState(false);
    const [isDataProceed, setIsDataProceed] = useState(false);
    const [isTopupSuccess, setIsTopupSuccess] = useState(false);
    const [isTopupFailed, setIsTopupFailed] = useState(false);
    const [topupInProgress, setTopupInProgress] = useState<any>([]);
    const [groupData, setGroupData] = useState<any>(null);
    const [dataTopup, setDataTopup] = useState<any>(0);
    const [topUpSize, setTopUpSize] = useState<any>(0);
    const [configVals, setConfigVals] = useState<any>(null);
    const [configLoaded, setConfigLoaded] = useState<boolean>(false);
    const [dataTopupCharges, setDataTopupCharges] = useState(10);
    const [dataUsage, setDataUsage] = useState<any>(null);
    const [dataUsageError, setDataUsageError] = useState<any>(false);
    // const [usedPercArr, setUsedPercArr] = useState<any>([]);
    // const [primaryUsedPerc, setPrimaryUsedPerc] = useState<number>(0);
    // const [primaryFormattedMax, setPrimaryFormattedMax] = useState<any>(null);
    // const [primaryFormattedUsed, setPrimaryFormattedUsed] = useState<any>(null);
    // const [formattedMaxArr, setFormatedMaxArr] = useState<any>(null);
    // const [formattedUsedArr, setFormatedUsedArr] = useState<any>(null);
    // const [primaryLoader, setPrimaryLoader] = useState<boolean>(false);
    // const [secondaryLoader, setSecondaryLoader] = useState<boolean>(false);
    const [viewLineStatus, setViewLineStatus] = useState('');
    const [lineLoader, setLineLoader] = useState('');
    const [isAddLineJourney, setIsAddLineJourney] = useState(false);
    const [isAddLineSummary, setIsAddLineSummary] = useState(false);
    const [isAddLineCharges, setIsAddLineCharges] = useState(false);
    const [isChangeAddress, setIsChangeAddress] = useState(false);
    const [isLineAdded, setIsLineAdded] = useState(false);
    const [isShipmentFailed, setIsShipmentFailed] = useState<boolean>(false);
    const [deviceDetails, setDeviceDetails] = useState<any>(null);
    const [isImeiData, setIsImeiData] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [creditLimitError, setCreditLimitError] = useState(false);
    const [topupPulseDetails, setTopupPulseDetails] = useState<any>(null);
    const [isInvalidImei, setIsInvalidImei] = useState(false);
    const [portFailedData, setPortFailedData] = useState<any>([]);
    const [width, setWidth] = useState<any>(window.innerWidth);
    // ---- HSD Changes ------
    const [primaryHsdDiscount, setPrimaryHsdDiscount] = useState<number>(0);
    const [secHsdDiscount, setSecHsdDiscount] = useState<number>(0);
    const [isHsdCustomer, setIsHsdCustomer] = useState<boolean>(false);
    const [currentPlan, setCurrentPlan] = useState<any>(null);
    const [preCheckLoader, setPreCheckLoader] = useState<any>('');
    const [selectedLine, setSelectedLine] = useState<any>('');
    const [currentIndex, setCurrentIndex] = useState<any>('');
    const [isFraudAcc, setIsFraudAcc] = useState<boolean>(false);
    const [trackOrderDetails, setTrackOrderDetails] = useState<any>(null);
    const [shipApiFailed, setShipApiFailed] = useState<boolean>(false);
    const [simSwapInProgress, setSimSwapInProgress] = useState<boolean>(false);
    const [isEditName, setIsEditName] = useState<boolean>(false);
    const [editUser, setEditUser] = useState<any>(null);

    const dispatch = useDispatch();

    const { postActivation, activation, home, trackOrder } = useSelector((state: any) => state);
    const reachPlanState = useSelector((state: any) => state.trackOrder.ReachPlan);
    const userPlan = useSelector((state: any) => state.billing.userPlans);
    const configState = useSelector((state: any) => state.billing.config);
    const { getOrderByCustomerId } = useSelector((state: any) => state.checkout);
    const {getCustomer} = useSelector((state: any) => state.checkout);
    // ---- HSD Changes ------
    // const { plans } = useSelector((state:any) => state.home);
    const { coupon } = useSelector((state: any) => state.checkout);

    let step3 = activationPage && activationPage.step3;
    const primaryFullName = useRef('');
    let setVal = useRef<boolean>(true);

    const activationStatusDataRef: any = useRef([]);
    const activationStatusCountRef = useRef(0);
    const topupStatusDataRef: any = useRef([]);
    const topupStatusCountRef = useRef(0);

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
        localStorage.removeItem('lineNumber');
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        localStorage.removeItem('secondaryCustomerDetail');
        setCustomerDetails(customerDetails);
        if(customerDetails?.category === 'FRAUD') {
            setIsFraudAcc(true);
        }
        // ---- HSD Changes ------
        setIsHsdCustomer(customerDetails?.hsdPlan);
        dispatch(GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }));
        dispatch(customerGroup({ groupId: customerDetails && customerDetails.groupId }));
        dispatch(dataUsageOverall({ customerId: customerDetails && customerDetails.id }));
        if (customerDetails.status === 2) {
            dispatch(userPlans({ customerId: customerDetails?.id }));
        } else {
            dispatch(reachPlan({ plan: customerDetails && customerDetails.reachPlanId }));
        }
        if (customerDetails && customerDetails.isPrimary) {
            dispatch(currentDataUsage({ customerId: customerDetails && customerDetails.id }));
        } else {
            dispatch(currentDataUsage({ customerId: customerDetails && customerDetails.parentId }));
        }
        dispatch(trackOrderGet({
            customerId: customerDetails?.id
        }))

        // dispatch(config(configPayload));
        dispatch(getAppData());
        dispatch(
            GetOrderByCustomerId({
                customerId: customerDetails && customerDetails.id,
            }),
        );
    }, []);

    const handleResize = () => {
        setWidth(window.innerWidth);
    }

    // ---- HSD Changes ------
    // useEffect(() => {
    //     if(plans && plans.status === "SUCCESS" && plans.data) {
    //         let customerDetails: any = localStorage.getItem('customerDetail');
    //         customerDetails = JSON.parse(customerDetails);
    //         const filtered: any = plans.data.filter((el:any) =>  el.name === customerDetails?.reachPlanId)

    //         filtered && filtered[0]?.wowCoupon && isHSDEnabled &&
    //         dispatch(Coupon({
    //             couponCode: filtered && filtered[0]?.wowCoupon
    //         }))
    //     }
    // },[plans])

    useEffect(() => {
        if (coupon && coupon.status === 'SUCCESS' && coupon.data) {
            if (isHsdCustomer) {
                setPrimaryHsdDiscount(coupon?.data?.discountInDollar);
                setSecHsdDiscount(coupon?.data?.secondaryDiscountInDollar);
            }
        }
    }, [coupon]);

    useEffect(() => {
        if (configState && configState.status === 'SUCCESS' && configState.data && configState.data.configs) {
            setDataTopup(configState.data.topupPulseDetails.pulse);
            setTopUpSize(configState.data.topupPulseDetails.pulse);
            setConfigVals(configState.data.configs);
            setTopupPulseDetails(configState.data?.topupPulseDetails);
            setConfigLoaded(true);
        }
    }, [configState]);

    useEffect(() => {
        if (reachPlanState && reachPlanState.status === 'SUCCESS' && reachPlanState.data) {
            localStorage.setItem('currentPlan', JSON.stringify(reachPlanState.data));
            setCurrentPlan(userPlan.data);
        }
    }, [reachPlanState]);

    useEffect(() => {
        const {TrackOrderGet, errorTrackOrderGet} = trackOrder;
        if (TrackOrderGet && TrackOrderGet.status === 'SUCCESS' && TrackOrderGet.data) {
            const shippingOrderDataOfAllLines = new Map();
            TrackOrderGet.data.forEach((data:any)=> {
                for (let key in data?.woNumberMap) {
                    let shipmentObject = {
                        trackingUrl: data?.trackingUrl,
                        orderDate: data?.orderDate,
                        labelledOn: data?.labelledOn,
                        shippedOn: data?.shippedOn,
                        deliveredOn: data?.deliveredOn,
                        estimatedDeliveryDate: data?.estimatedDeliveryDate,
                        trackingNumber: data?.trackingNumber,
                        orderStatus: data?.orderStatus,
                        woNumber: data?.woNumberMap[key],
                        orderType: data?.orderType
                    };
                    if (shippingOrderDataOfAllLines.has(key)) {
                        shippingOrderDataOfAllLines.set(key, shipmentObject);
                      } else {
                        const currentShipmentData = shippingOrderDataOfAllLines.get(key);
                        if (currentShipmentData?.orderType != "RE_ORDER") {
                          shippingOrderDataOfAllLines?.delete(key);
                          shippingOrderDataOfAllLines.set(key, shipmentObject);
                        }
                      }
                }
            })
            setTrackOrderDetails(shippingOrderDataOfAllLines)
        } else if (errorTrackOrderGet && errorTrackOrderGet.status === 'FAILURE') {
            setShipApiFailed(true);
        }
    },[trackOrder.TrackOrderGet, trackOrder.errorTrackOrderGet])

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current) {
            initialRender1.current = false;
        } else {
            if (
                postActivation &&
                postActivation.group &&
                postActivation.group.data &&
                postActivation.group.data.length > 0
            ) {
                // let usedImeiArr: any = [];
                // postActivation.group.data.map((data: any) => usedImeiArr.push(data.imei));
                // localStorage.setItem('usedImeiNos', JSON.stringify(usedImeiArr));

                // const isAllLineActive = postActivation.group.data.every((data: any) => data.status === 2);
                setLoader(false);
                setGroupData(postActivation.group.data);

                let totalLines = postActivation.group.data.filter(
                    (data: any) => data.status !== 4 && data.status !== 7,
                );
                totalLines = totalLines.length;
                localStorage.setItem('numOfLines', JSON.stringify(totalLines));

                if (totalLines >= 5) {
                    setIsDisabled(true);
                } else {
                    setIsDisabled(false);
                }

                let activationStatusData = postActivation.group.data.filter(
                    (data: any) => data.status === 1 || data.status === 8 || data.status === 9 || data.status === 10,
                );
                setPortFailedData(null);
                if (activationStatusData.length > 0) {
                    activationStatusDataRef.current = activationStatusData;
                    if(!isAddDataJourney && !isAddLineJourney) {
                        dispatch(activationStatus({ customerId: activationStatusDataRef.current[0].id }));
                    }
                    activationStatusCountRef.current = 1;
                }

                let topupStatusData = postActivation.group.data.filter((data: any) => data.status === 2);
                if (topupStatusData && topupStatusData.length > 0) {
                    topupStatusDataRef.current = topupStatusData;
                    dispatch(topUpCustomerStatus({ customerId: topupStatusDataRef.current[0].id }));
                    topupStatusCountRef.current = 1;
                }
            }
        }
    }, [postActivation.group]);

    const initialRender11 = useRef(true);
    useEffect(() => {
        if (initialRender11.current) {
            initialRender11.current = false;
        } else {
            if (
                postActivation &&
                postActivation.activationPrecheck &&
                postActivation.activationPrecheck.status === 'SUCCESS'
            ) {
                setPreCheckLoader('');
                localStorage.setItem('lineNumber', JSON.stringify(currentIndex + 1));
                if (!selectedLine?.isPrimary) {
                    localStorage.setItem('secondaryCustomerDetail', JSON.stringify(selectedLine));
                }
                props.history.push({
                    pathname: selectedLine.esim ? '/activate-esim' : '/track-order',
                    orderId:
                        Object.keys(selectedLine.shipmentInfo).length !== 0
                            ? Object.keys(selectedLine.shipmentInfo)[0]
                            : Object.keys(customerDetails.shipmentInfo)[0],
                });
            }
            if (
                postActivation &&
                postActivation.errorActivationPrecheck &&
                postActivation.errorActivationPrecheck.status === 'FAILURE' &&
                postActivation.errorActivationPrecheck.resCode === 40624
            ) {
                setPreCheckLoader('');
                props.history.push('/activation-error');
            }
        }
    }, [postActivation.activationPrecheck, postActivation.errorActivationPrecheck]);

    const initialRender10 = useRef(true);
    useEffect(() => {
        if (initialRender10.current) {
            initialRender10.current = false;
        } else {
            if (
                activation &&
                activation.activationStatus &&
                activation.activationStatus.data &&
                activation.activationStatus.status === 'SUCCESS'
            ) {
                let data = activation.activationStatus.data;
                if (activationStatusDataRef.current.length > activationStatusCountRef.current) {
                    dispatch(
                        activationStatus({
                            customerId: activationStatusDataRef.current[activationStatusCountRef.current].id,
                        }),
                    );
                    activationStatusCountRef.current = activationStatusCountRef.current + 1;
                }

                if (data.status === 1 || data.status === 8 || data.status === 9 || data.status === 10) {
                    if(!isAddDataJourney && !isAddLineJourney) {
                        setTimeout(() => {
                            dispatch(activationStatus({ customerId: data.customerId }));                            
                        }, 30000);
                    }
                } else {
                    let user: any = localStorage.getItem('customerDetail');
                    user = JSON.parse(user);
                    dispatch(customerGroup({ groupId: user && user.groupId }));
                }

                if (data.status === 10) {
                    if (portFailedData) {
                        const findData = portFailedData.find(
                            (d: any) => d.customerId === data.customerId && d.status === data.status,
                        );
                        if (!findData) {
                            setPortFailedData((oldArr: any) => [...oldArr, activation.activationStatus.data]);
                        }
                    } else {
                        setPortFailedData([activation.activationStatus.data]);
                    }
                }
            }
        }
    }, [activation.activationStatus]);

    const initialRender2 = useRef(true);
    useEffect(() => {
        if (initialRender2.current) {
            initialRender2.current = false;
        } else {
            if (
                postActivation &&
                postActivation.topUpCustomer &&
                postActivation.topUpCustomer.status === 'SUCCESS' &&
                postActivation.topUpCustomer.data
            ) {
                let customerDetails: any = localStorage.getItem('customerDetail');
                customerDetails = JSON.parse(customerDetails);
                dispatch(
                    topUpCustomerStatus({
                        customerId:
                            userPlan?.data?.isUnlimited && user && user.id
                                ? user.id
                                : customerDetails && customerDetails.id,
                    }),
                );
                dispatch(customerGroup({ groupId: customerDetails && customerDetails.groupId }));
            }
            if (
                postActivation &&
                postActivation.errorTopUpCustomer &&
                postActivation.errorTopUpCustomer.status === 'FAILURE'
            ) {
                setIsDataProceed(false);
                setIsBuyDataClicked(false);
                if (postActivation.errorTopUpCustomer.resCode === 40625) {
                    setCreditLimitError(true);
                    setIsAddData(true);
                } else {
                    setIsTopupFailed(true);
                }
            }
        }
    }, [postActivation.topUpCustomer, postActivation.errorTopUpCustomer]);

    const initialRender5 = useRef(true);
    useEffect(() => {
        if (initialRender5.current) {
            initialRender5.current = false;
        } else {
            if (
                postActivation &&
                postActivation.topUpCustomerStatus &&
                postActivation.topUpCustomerStatus.status === 'SUCCESS' &&
                postActivation.topUpCustomerStatus.data
            ) {
                if (isAddDataJourney) {
                    if (postActivation.topUpCustomerStatus.data.status === 'SUCCESSFUL') {
                        setIsBuyDataClicked(false);
                        setIsDataProceed(false);
                        setIsTopupSuccess(true);
                    }
                    if (postActivation.topUpCustomerStatus.data.status === 'IN_PROGRESS') {
                        setIsAddDataJourney(false);
                        setIsBuyDataClicked(false);
                        setIsDataProceed(false);
                        setTopupInProgress([...topupInProgress, postActivation.topUpCustomerStatus.data.customerId]);
                    }
                    dispatch(currentDataUsage({ customerId: customerDetails && customerDetails.id }));
                    // setLoader(true);
                }

                if (!isAddDataJourney) {
                    if (topupStatusDataRef.current.length > topupStatusCountRef.current) {
                        dispatch(
                            topUpCustomerStatus({
                                customerId: topupStatusDataRef.current[topupStatusCountRef.current].id,
                            }),
                        );
                        topupStatusCountRef.current = topupStatusCountRef.current + 1;
                    }
                    if (postActivation.topUpCustomerStatus.data.status === 'IN_PROGRESS') {
                        setTopupInProgress([...topupInProgress, postActivation.topUpCustomerStatus.data.customerId]);
                    }
                }
            }
            if (
                postActivation &&
                postActivation.errorTopUpCustomerStatus &&
                postActivation.errorTopUpCustomerStatus.status === 'FAILURE'
            ) {
                setIsBuyDataClicked(false);
            }
        }
    }, [postActivation.topUpCustomerStatus, postActivation.errorTopUpCustomerStatus]);

    const initialRender6 = useRef(true);
    useEffect(() => {
        if (initialRender6.current) {
            initialRender6.current = false;
        } else {
            if (
                getOrderByCustomerId &&
                getOrderByCustomerId.status === 'SUCCESS' &&
                getOrderByCustomerId.data.length > 0
            ) {
                let woNumbers: any = {};
                getOrderByCustomerId.data.map((data: any) => {
                    Object.assign(woNumbers, data.woNumberMap);
                });
                localStorage.setItem('woNumberMap', JSON.stringify(woNumbers));
            }
        }
    }, [getOrderByCustomerId]);

    const initialRender3 = useRef(true);
    useEffect(() => {
        if (initialRender3.current) {
            initialRender3.current = false;
        } else {
            if (
                activation &&
                activation.currentDataUsage &&
                activation.currentDataUsage.status === 'SUCCESS' &&
                activation.currentDataUsage.data
            ) {
                setDataUsageError(false);
                setLineLoader('');
                let arr: any = [];
                groupData?.map((el: any, _idx: number) => {
                    let endDate: any;
                    if (el.billEndDate) {
                        endDate = new Date(el?.billEndDate).toISOString().slice(0, 10);
                        arr.push(endDate);
                    }
                });

                let uniqueDates = arr.filter((c: any, index: any) => {
                    return arr.indexOf(c) === index;
                });
                let dataUsageArr: any = [];
                groupData?.map((_el: any, _idx: number) => {
                    if (uniqueDates) {
                        let d: any = activation.currentDataUsage.data[uniqueDates[_idx]];
                        let len: any = d?.users?.length;
                        if (d?.users) {
                            for (let i = 0; i < len; i++) {
                                dataUsageArr.push(d.users[i]);
                            }
                        }
                    }
                });
                setDataUsage(dataUsageArr);
                setVal.current = true;
            }
            if (
                activation &&
                activation.errorCurrentDataUsage &&
                activation.errorCurrentDataUsage.status === 'FAILURE'
            ) {
                setLineLoader('');
                if (!_.isEmpty(activation?.dataUsage?.data)) {
                    let userData: any = localStorage.getItem('customerDetail');
                    userData = JSON.parse(userData);
                    const currentBillDate = moment
                        .utc(userData?.nextBillingDate)
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD');
                    if (currentBillDate) {
                        let dataUsageArr: any = activation.dataUsage.data[currentBillDate]?.users;
                        setDataUsage(dataUsageArr);
                    }
                } else {
                    dispatch(dataUsageOverall({ customerId: customerDetails && customerDetails.id }));
                }
            }
        }
    }, [activation.currentDataUsage, activation.errorCurrentDataUsage]);

    const initialRender4 = useRef(true);
    useEffect(() => {
        if (initialRender4.current) {
            initialRender4.current = false;
        } else {
            if (userPlan && userPlan.status === 'SUCCESS' && userPlan.data) {
                localStorage.setItem('currentPlan', JSON.stringify(userPlan.data));
                setCurrentPlan(userPlan.data);
                let couponName: any = null;
                if(userPlan.data?.wowCoupon) {
                    couponName = userPlan.data?.wowCoupon
                }
                isHsdCustomer &&
                    isHSDEnabled &&
                    dispatch(
                        Coupon({
                            couponCode: couponName,
                        }),
                    );
            }
        }
    }, [userPlan]);

    const initialRender7 = useRef(true);
    useEffect(() => {
        if (initialRender7.current) {
            initialRender7.current = false;
        } else {
            if (home && home.plans && home.plans.status === 'SUCCESS' && home.plans.data) {
                let couponName: any = null;
                home.plans.data.map((el: any) => {
                    if (el?.name === currentPlan?.name && el?.wowCoupon) {
                        couponName = el.wowCoupon;
                    }
                });
                isHsdCustomer &&
                    isHSDEnabled &&
                    dispatch(
                        Coupon({
                            couponCode: couponName,
                        }),
                    );
            }
        }
    }, [home.plans]);

    const initialRender8 = useRef(true);
    useEffect(() => {
        if (initialRender8.current) {
            initialRender8.current = false;
        } else {
            setDataTopupCharges((topupPulseDetails?.pulseCost / topupPulseDetails?.pulse) * dataTopup);
        }
    }, [dataTopup]);

    const initialRender9 = useRef(true);
    useEffect(() => {
        if (initialRender9.current) {
            initialRender9.current = false;
        } else {
            if (
                activation.dataUsage &&
                activation.dataUsage.status === 'SUCCESS' &&
                activation.dataUsage.data &&
                !_.isEmpty(activation.dataUsage.data)
            ) {
                if (
                    activation &&
                    activation.errorCurrentDataUsage &&
                    activation.errorCurrentDataUsage.status === 'FAILURE'
                ) {
                    let userData: any = localStorage.getItem('customerDetail');
                    userData = JSON.parse(userData);
                    const currentBillDate = moment
                        .utc(userData?.nextBillingDate)
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD');
                    if (currentBillDate) {
                        let dataUsageArr: any = activation.dataUsage.data[currentBillDate]?.users;
                        console.log('dataUsageArr', dataUsageArr);
                        setDataUsage(dataUsageArr);
                    }
                }

                if (Object.keys(activation.dataUsage.data).length > 1) {
                    const sortedKeys = Object.keys(activation.dataUsage.data).sort((a: any, b: any) => {
                        const date1: any = new Date(a);
                        const date2: any = new Date(b);
                        return date1 - date2;
                    });
                    localStorage.setItem('billCycle', JSON.stringify(sortedKeys));
                }
            }

            if (activation && activation.errorDataUsage && activation.errorDataUsage.status === 'FAILURE') {
                if (activation.errorCurrentDataUsage && activation.errorCurrentDataUsage.status === 'FAILURE') {
                    setDataUsageError(true);
                }
            }
        }
    }, [activation.dataUsage, activation.errorDataUsage]);
    
    const initialRender12 = useRef(true);
    useEffect(()=> {
        if (initialRender12.current) {
            initialRender12.current = false;
        } else {
            if (
                getCustomer &&
                getCustomer.status === 'SUCCESS' &&
                getCustomer.data &&
                getCustomer.data.operationsInProcess
            ) {
                if (getCustomer.data.operationsInProcess.includes('SIM_SWAP_IN_PROGRESS')) {
                    setSimSwapInProgress(true);
                    let customerDetails: any = localStorage.getItem('customerDetail');
                    customerDetails = JSON.parse(customerDetails);
                    let timer: any = 60000;
                    setTimeout(() => {
                        dispatch(
                            GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }),
                        );
                    }, timer);
                } else {
                    setSimSwapInProgress(false);
                }
            }
        }
    },[getCustomer])

    const initialRender13 = useRef(true);
    useEffect(() => {
        if (initialRender13.current) {
            initialRender13.current = false;
        } else {
            setLoader(true);
            let customerDetails: any = localStorage.getItem('customerDetail');
            customerDetails = JSON.parse(customerDetails);
            dispatch(customerGroup({ groupId: customerDetails && customerDetails.groupId }));
        }
    }, [isEditName]);

    const backHandler = () => {
        setDataTopup(configState.data.configs.AUTO_TOP_UP_SIZE);
        if (isAddData) {
            setIsAddDataJourney(false);
            setIsAddData(false);
            setCreditLimitError(false);
        } else if (isDataProceed) {
            setIsDataProceed(false);
            setIsAddData(true);
        } else {
            setIsAddData(false);
            setIsDataProceed(false);
            setIsTopupSuccess(false);
        }
    };

    const addLineBackHandler = () => {
        if (isAddLineJourney) {
            if (isAddLineSummary) {
                setIsAddLineSummary(false);
            } else if (isAddLineCharges) {
                setIsAddLineCharges(false);
            } else {
                setIsAddLineJourney(false);
                setIsImeiData(false);
            }
        }
    };

    const handleAddData = () => {
        setIsDataProceed(true);
        setIsAddData(false);
        let userDetails: any = userPlan?.data?.isUnlimited ? user : customerDetails;
        let occurence: any = userDetails.peerAccountRef.split('|')[2];
        TagManager.dataLayer({
            dataLayer: {
                event: 'Proceed',
                accountNo: customerDetails?.meta?.customer_statement_number,
                line_number: occurence,
                Topup_size: dataTopup,
            },
        });
        // GAAndFBEventsHandler("Proceed", customerDetails?.meta?.customer_statement_number,occurence, dataTopup)
    };

    const callTopupApi = () => {
        setIsBuyDataClicked(true);
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        let payload: any = {
            customerId:
                user && user.id ? user.id : customerDetails && customerDetails.id,
                // userPlan?.data?.isUnlimited && user && user.id ? user.id : customerDetails && customerDetails.id,
            totalData: dataTopup,
            taxInfo: {
                customerId: customerDetails && customerDetails.id,
            },
        };
        dispatch(topUpCustomer(payload));
        let userDetails: any = userPlan?.data?.isUnlimited ? user : customerDetails;
        let occurence: any = userDetails.peerAccountRef.split('|')[2];
        TagManager.dataLayer({
            dataLayer: {
                event: 'Confirm',
                accountNo: customerDetails?.meta?.customer_statement_number,
                line_number: occurence,
                Topup_size: dataTopup,
            },
        });
        // GAAndFBEventsHandler("Confirm", customerDetails?.meta?.customer_statement_number,occurence, dataTopup)
    };

    const handleTopupSuccess = () => {
        setIsTopupSuccess(false);
        setIsDataProceed(false);
        setIsAddData(false);
        setIsAddDataJourney(false);
        setDataTopup(topUpSize);
    };

    const formatBytes = (bytes: number) => {
        const k = 1024;
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return bytes / Math.pow(k, i);
    };

    const handleDataTopup = (val: string) => {
        // let data: any = configVals.TOPUP_DATA_LIMIT - user?.totalTopupInGB;
        let data: any = configVals.TOPUP_DATA_LIMIT;
        if (val === 'increment') {
            if (dataTopup == data) return;
            setDataTopup(parseInt(dataTopup) + parseInt(topUpSize));
            let userDetails: any = userPlan?.data?.isUnlimited ? user : customerDetails;
            let occurence: any = userDetails.peerAccountRef.split('|')[2];
            TagManager.dataLayer({
                dataLayer: {
                    event: 'Size_Change',
                    accountNo: customerDetails?.meta?.customer_statement_number,
                    line_number: occurence,
                    Topup_size: parseInt(dataTopup) + parseInt(topUpSize),
                },
            });
            // GAAndFBEventsHandler("Size_Change",
            //     customerDetails?.meta?.customer_statement_number,
            //     occurence,
            //     parseInt(dataTopup) + parseInt(topUpSize)
            // )
        } else if (val === 'decrement') {
            if (dataTopup <= topUpSize) return;
            setDataTopup(parseInt(dataTopup) - parseInt(topUpSize));
            let userDetails: any = userPlan?.data?.isUnlimited ? user : customerDetails;
            let occurence: any = userDetails.peerAccountRef.split('|')[2];
            TagManager.dataLayer({
                dataLayer: {
                    event: 'Size_Change',
                    accountNo: customerDetails?.meta?.customer_statement_number,
                    line_number: occurence,
                    Topup_size: parseInt(dataTopup) - parseInt(topUpSize),
                },
            });
            // GAAndFBEventsHandler("Size_Change",
            //     customerDetails?.meta?.customer_statement_number,
            //     occurence,
            //     parseInt(dataTopup) - parseInt(topUpSize)
            // )
        }
    };

    const setPrimaryUserFullName = (user: any) => {
        if (user.isPrimary) {
            primaryFullName.current = user?.firstName ? user.firstName : user?.lastName;
        }
    };

    const handleAddLineBtn = () => {
        window.scroll(0, 0);
        setIsAddLineJourney(true);
        setIsImeiData(false);
        setIsLineAdded(false);
        setIsAddLineSummary(false);
        setIsAddLineCharges(false);
        TagManager.dataLayer({
            dataLayer: {
                event: 'Add_Line',
            },
        });
        // GAAndFBEventsHandler("Add_Line")
    };
    function convertToOrdinal(number: any) {
        const ordinalWords = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth'];
        const value = parseInt(number);
        return ordinalWords[value];
    }

    const moveToActivationStatus = (data: any) => {
        let cust: any = groupData.filter((el: any) => data.customerId === el.id);
        cust = cust[0];
        if (data?.portFailureCode) {
            props.history.push({
                pathname: '/status',
                state: {
                    portFailedData: data,
                },
            });
        } else {
            props.history.push({
                pathname: '/activation',
                state: {
                    portFailedData: data,
                    fromPortFailed: true,
                    redirectOnClick: true,
                },
            });
            if (!cust.isPrimary) {
                localStorage.setItem('secondaryCustomerDetail', JSON.stringify(cust));
            }
        }
    };

    const backShippingFailed = () => {
        setIsShipmentFailed(false);
        setIsAddLineJourney(false);
        setIsImeiData(false);
        setIsLineAdded(false);
        setIsAddLineSummary(false);
        setIsAddLineCharges(false);
    };

    const gotoActivationHandler = (el: any, _idx:any) => {
        dispatch(activationPrecheck({ id: el.id}))
        setPreCheckLoader(el.id);
        setSelectedLine(el);
        setCurrentIndex(_idx);
        let occurence = el.peerAccountRef.split('|')[2];
        TagManager.dataLayer({
            dataLayer: {
                event: el.sim ? 'Activate' : 'Track_Order',
                accountNo: customerDetails?.meta?.customer_statement_number,
                line_number: occurence,
            },
        });
    }
    const editNameHandler = (el: any) => {
        setEditUser(el);
        setIsEditName(true);
    };
    return (
        <div className="astoundHomePage">
            <Helmet>
                <title>{seoData.home.title}</title>
                <meta property="og:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta property="og:title" name="title" content={seoData.home.title} />
                <meta property="og:description" name="description" content={seoData.home.description} />
                <meta name="description" content={seoData.home.description} />
                <meta name="keywords" content={seoData.home.keywords} />
                <meta name="robots" content="noindex, nofollow" />
                <meta property="twitter:site_name" name="site_name" content={globalVal && globalVal.long_name} />
                <meta name="twitter:title" content={seoData.home.title} />
                <meta name="twitter:description" content={seoData.home.description} />
                <link rel="canonical" href={seoData.home.canonicalUrl} />
            </Helmet>
            {customerDetails &&
            !isShipmentFailed &&
            (customerDetails.status == 1 ||
                customerDetails.status == 2 ||
                customerDetails.status == 3 ||
                customerDetails.status == 4 ||
                customerDetails.status == 5 ||
                customerDetails.status == 8 ||
                customerDetails.status == 9 ||
                customerDetails.status == 10) && 
                configLoaded ? (
                <PostHeader 
                    history={props.history}
                    showServiceTab = {configVals?.SERVICE_TAB === 'ENABLE' ? true : false}
                // enableServiceInPrimarySus={configState?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED} 
                />
            ) : (
                <SimpleHeader history={props.history} isHelp={true} user={customerDetails} />
            )}
            {!isShipmentFailed && (
                <div className="OverlayPlan">
                    <div className="carouseImage">
                        <img className="web" width="100%" src={image} alt={altText.planPage.mainImage} />
                        <img className="iPadPro" width="100%" src={image1} alt={altText.planPage.mainImage} />
                        <img className="iPad" width="100%" src={image2} alt={altText.planPage.mainImage} />
                        <img
                            className="mobile"
                            src={mobileImg}
                            height={213}
                            width="100%"
                            alt={altText.planPage.mainImage}
                        />
                        <div className="contentCarousel">
                            <h1 style={{ display: 'none' }}>Account</h1>
                            <div className="Goodbye-mobile-store">Home</div>
                        </div>
                    </div>
                </div>
            )}
            {!isAddDataJourney && !isAddLineJourney && !isEditName &&  (
                <div className="planDetails">
                    {loader ? (
                        <div className="loaderCheck">
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            {customerDetails &&
                                customerDetails.status === 3 &&
                                customerDetails.isPrimary &&
                                customerDetails.lastDisconnectedReason === 1 ||
                                isFraudAcc && (
                                    <div className="suspendedDiv">
                                        <div className="suspendedTitle">Let’s Talk</div>
                                        <div className="suspendedMsg">
                                            We’re sorry. The service you’re attempting to access or update is
                                            temporarily unavailable.
                                        </div>
                                        <div className="suspendedContact">
                                            Please contact us at <span>1.800.427.8686</span>
                                        </div>
                                    </div>
                                )}
                            {customerDetails && customerDetails.status === 7 && customerDetails.isPrimary && (
                                <GenericError isDisabled={true} />
                            )}
                            <div>
                                {customerDetails &&
                                    customerDetails.status !== 7 &&
                                    groupData &&
                                    groupData
                                        .filter(
                                            (el: any) =>
                                                el?.status === 0 ||
                                                el?.status === 1 ||
                                                el?.status === 2 ||
                                                el?.status === 3 ||
                                                el?.status === 4 ||
                                                el?.status === 5 ||
                                                el?.status === 6 ||
                                                el?.status === 8 ||
                                                el?.status === 9 ||
                                                el?.status === 10 ||
                                                el?.status === 11,
                                        )
                                        .sort(
                                            (x: any, y: any) =>
                                                y.isPrimary - x.isPrimary ||
                                                toNumber(x.peerAccountRef?.split('|')[2]) -
                                                    toNumber(y.peerAccountRef?.split('|')[2]),
                                        )
                                        .map((el: any, _idx: any) => {
                                            let usedUnits: any;
                                            let usedBytes: any;
                                            let maxBytes;
                                            let useData;
                                            let maxData;
                                            if (dataUsage) {
                                                const userData =
                                                    dataUsage && dataUsage.find((data: any) => data.userId === el.id);
                                                useData = userData?.bytes ? userData.bytes : 0;
                                                maxData = userData?.maxBytes ? userData.maxBytes : 0;
                                                if (useData > maxData) {
                                                    useData = maxData;
                                                }
                                                usedUnits = (useData / maxData) * 100;
                                                usedBytes = bytesToSize(useData);
                                                maxBytes = formatBytes(maxData);
                                            }
                                            return (
                                                <div
                                                    key={el.id}
                                                    className={
                                                        el.id === viewLineStatus ||
                                                        !el.simPaid ||
                                                        topupInProgress.includes(el.id)
                                                            ? 'HomeLineCard HomeLineCardHeight'
                                                            : 'HomeLineCard'
                                                    }
                                                >
                                                    <div className="lineCard">
                                                        <div className="cusDetails">
                                                            <div>
                                                                <span
                                                                    className={
                                                                        el.status === 4 || el.status === 3
                                                                            ? 'cusDetailsLite'
                                                                            : ''
                                                                    }
                                                                >
                                                                    {el?.firstName || el?.lastName
                                                                        ? width <= 768
                                                                            ? textTruncate(returnName(el, "firstName")) + ' ' + textTruncate(returnName(el, "lastName"))?.toUpperCase()
                                                                            : returnName(el, "firstName") + ' ' + returnName(el, "lastName")
                                                                        : convertToOrdinal(
                                                                            el.peerAccountRef?.split('|')[2] - 1,
                                                                        ).toUpperCase() + "'s" + ' LINE'}{' '}
                                                                    {setPrimaryUserFullName(el)}
                                                                </span>
                                                                <br />
                                                                {el.status === 4 || el.status === 3 ? (
                                                                    <>
                                                                        <span className="cusStatus">
                                                                            {el.status === 4 ? 'Disconnected' :
                                                                                customerDetails?.meta?.suspended_reason === "NonPay Suspension" ? 'Suspended' : ''}
                                                                        </span>
                                                                        <span className="cusSimPref">
                                                                            {el && el.reachNumber ? (
                                                                                <span className="cusPrimary" style={{ color: "#ACACAF" }}>
                                                                                    {`(${el.reachNumber.slice(
                                                                                        0,
                                                                                        3,
                                                                                    )}) ${el.reachNumber.slice(
                                                                                        3,
                                                                                        6,
                                                                                    )}-${el.reachNumber.slice(6)} `}
                                                                                </span>
                                                                            ) : el && el.mnpInfo?.oldNumber ? (
                                                                                <span className="cusPrimary" style={{ color: "#ACACAF" }}>
                                                                                    {`(${el.mnpInfo?.oldNumber.slice(
                                                                                        0,
                                                                                        3,
                                                                                    )}) ${el.mnpInfo?.oldNumber.slice(
                                                                                        3,
                                                                                        6,
                                                                                    )}-${el.mnpInfo?.oldNumber.slice(6)} `}
                                                                                </span>
                                                                            ) : null}
                                                                            <span style={{ color: "#ACACAF" }}>{el.esim ? 'eSIM' : 'SIM'}</span>
                                                                        </span>
                                                                        {el.isPrimary && (
                                                                            <span className="cusPrimary" style={{ color: "#ACACAF" }}>(Primary)</span>
                                                                        )}{' '}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <span className="cusSimPref">
                                                                            {el && el.reachNumber ? (
                                                                                <span className="cusPrimary">
                                                                                    {`(${el.reachNumber.slice(
                                                                                        0,
                                                                                        3,
                                                                                    )}) ${el.reachNumber.slice(
                                                                                        3,
                                                                                        6,
                                                                                    )}-${el.reachNumber.slice(6)} `}
                                                                                </span>
                                                                            ) : el && el.mnpInfo?.oldNumber ? (
                                                                                <span className="cusPrimary">
                                                                                    {`(${el.mnpInfo?.oldNumber.slice(
                                                                                        0,
                                                                                        3,
                                                                                    )}) ${el.mnpInfo?.oldNumber.slice(
                                                                                        3,
                                                                                        6,
                                                                                    )}-${el.mnpInfo?.oldNumber.slice(6)} `}
                                                                                </span>
                                                                            ) : null}
                                                                            {el.esim ? 'eSIM' : 'SIM'}
                                                                        </span>
                                                                        {el.isPrimary && (
                                                                            <span className="cusPrimary">(Primary)</span>
                                                                        )}{' '}
                                                                    </>
                                                                )}
                                                            </div>
                                                            {el.status === 2 && !el.isPrimary && (
                                                                <div className="editName">
                                                                    <img
                                                                        onClick={() => editNameHandler(el)}
                                                                        src={editIcon}
                                                                        alt="editIcon"
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="vLine"></div>
                                                        {(el.status === 0 || el.status === 11) && (
                                                            <div className="trackOrder">
                                                                {el.id === preCheckLoader ? (
                                                                    <div
                                                                        style={{ marginRight: '40px' }}
                                                                        className="loaderCheck text-center"
                                                                    >
                                                                        <CircularProgress />
                                                                    </div>
                                                                ) : (
                                                                    <div
                                                                        className={
                                                                            (customerDetails.status !== 2 &&
                                                                                !el.isPrimary &&
                                                                                !configState?.data?.configs
                                                                                    ?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED) ||
                                                                            !el.simPaid ||
                                                                            customerDetails?.meta?.suspended_reason ===
                                                                                'NonPay Suspension' ||
                                                                                isFraudAcc
                                                                                ? 'trackOrderCTA disableCTA'
                                                                                : 'trackOrderCTA'
                                                                        }
                                                                        onClick={() => {
                                                                            if(!trackOrderDetails?.has(el.id) 
                                                                                && customerDetails?.category === 'TEST' || shipApiFailed
                                                                            ) {
                                                                                if(!el?.isPrimary) {
                                                                                    localStorage.setItem(
                                                                                        'secondaryCustomerDetail',
                                                                                        JSON.stringify(el),
                                                                                    );
                                                                                }
                                                                                props.history.push({
                                                                                    pathname: '/activation',
                                                                                    id: el.id,
                                                                                    state: {
                                                                                        goBackToHome: true,
                                                                                    },
                                                                                });
                                                                            } else {
                                                                                gotoActivationHandler(el, _idx)
                                                                            }
                                                                        }}
                                                                    >
                                                                        {el.esim ? 'ACTIVATE' : 'TRACK ORDER'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {el.status === 1 && (
                                                            <div className="activationFailed">
                                                                <img src={portingLoaderIcon} alt="failedIcon" />
                                                                <span>Activation in progress…</span>
                                                            </div>
                                                        )}
                                                        {el.status === 8 && (
                                                            <div className="activationFailed">
                                                                <img src={redSimIcon} alt="failedIcon" />
                                                                <span>Activation Failed</span>
                                                                <div
                                                                    className="showMore"
                                                                    onClick={() => {
                                                                        if (viewLineStatus === el.id) {
                                                                            setViewLineStatus('');
                                                                        } else {
                                                                            setViewLineStatus(el.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    {viewLineStatus === el.id
                                                                        ? 'Show Less Info'
                                                                        : 'Show More Info'}
                                                                    <img
                                                                        src={
                                                                            viewLineStatus === el.id
                                                                                ? upArrow
                                                                                : downArrow
                                                                        }
                                                                        alt="historyIcon"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {el.status === 9 && (
                                                            <div className="activationFailed">
                                                                <img src={portingLoaderIcon} alt="failedIcon" />
                                                                <span>Porting in progress…</span>
                                                            </div>
                                                        )}
                                                        {el.status === 10 && (
                                                            <div className="activationFailed">
                                                                <img src={redSimIcon} alt="failedIcon" />
                                                                <span>Port in unsuccessful</span>
                                                                <div
                                                                    className="showMore"
                                                                    onClick={() => {
                                                                        if (viewLineStatus === el.id) {
                                                                            setViewLineStatus('');
                                                                        } else {
                                                                            setViewLineStatus(el.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    {viewLineStatus === el.id
                                                                        ? 'Show Less Info'
                                                                        : 'Show More Info'}
                                                                    <img
                                                                        src={
                                                                            viewLineStatus === el.id
                                                                                ? upArrow
                                                                                : downArrow
                                                                        }
                                                                        alt="historyIcon"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(el.status === 4 || el.status === 3) && (
                                                            <div className="activationFailed">
                                                                {el.status === 3 && 
                                                                customerDetails?.meta?.suspended_reason !== "NonPay Suspension" && (
                                                                    <span className='susText'>Voluntary suspended</span>
                                                                )}
                                                                <div
                                                                    className="showMore"
                                                                    onClick={() => {
                                                                        if (viewLineStatus === el.id) {
                                                                            setViewLineStatus('');
                                                                        } else {
                                                                            setViewLineStatus(el.id);
                                                                        }
                                                                    }}
                                                                >
                                                                    {viewLineStatus === el.id
                                                                        ? 'Show Less Info'
                                                                        : 'Show More Info'}
                                                                    <img
                                                                        src={
                                                                            viewLineStatus === el.id
                                                                                ? upArrow
                                                                                : downArrow
                                                                        }
                                                                        alt="historyIcon"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        {el.status === 2 &&
                                                            el.status !== 8 &&
                                                            (el.esim && !el.eSimSetup && useData === 0 ? (
                                                                <div className= { 
                                                                        isFraudAcc ? 
                                                                        'completeEsimSetup disableCTA' : 
                                                                        "completeEsimSetup"
                                                                    }
                                                                >
                                                                    <span
                                                                        onClick={() => {
                                                                            if(!isFraudAcc) {
                                                                                if (!el.isPrimary) {
                                                                                    localStorage.setItem(
                                                                                        'secondaryCustomerDetail',
                                                                                        JSON.stringify(el),
                                                                                    );
                                                                                }
                                                                                props.history.push('/steps');
                                                                            }
                                                                        }}
                                                                    >
                                                                        COMPLETE eSIM SETUP
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <div className="activeUser">
                                                                    {!dataUsageError ? (
                                                                        <div className="progressBar">
                                                                            <ProgressBar
                                                                                now={usedUnits}
                                                                                // now={primaryUsedPerc}
                                                                                max={100}
                                                                                min={0}
                                                                                className={
                                                                                    usedUnits >= 90
                                                                                        ? 'AccountCardProgressRed AccountCardProgress'
                                                                                        : 'AccountCardProgress'
                                                                                }
                                                                            />
                                                                            <div className="userDataUsage">
                                                                                <div>
                                                                                    {usedBytes || maxBytes ? (
                                                                                        <>
                                                                                            <span
                                                                                                className={
                                                                                                    usedUnits >= 90
                                                                                                        ? 'usedBytesRed'
                                                                                                        : 'usedBytes'
                                                                                                }
                                                                                            >
                                                                                                {usedBytes}
                                                                                            </span>{' '}
                                                                                            of{' '}
                                                                                            {!Number.isNaN(maxBytes)
                                                                                                ? maxBytes
                                                                                                : 0}{' '}
                                                                                            GB
                                                                                            {lineLoader === el.id ? (
                                                                                                <span className="refreshIconBlk">
                                                                                                    <img
                                                                                                        src={
                                                                                                            refreshIcon1
                                                                                                        }
                                                                                                        alt="refershIcon"
                                                                                                        width="15px"
                                                                                                        height="15px"
                                                                                                    />
                                                                                                </span>
                                                                                            ) : (
                                                                                                <span
                                                                                                    className="refreshIconBlk"
                                                                                                    onClick={() => {
                                                                                                        dispatch(
                                                                                                            currentDataUsage(
                                                                                                                {
                                                                                                                    customerId:
                                                                                                                        customerDetails.id,
                                                                                                                },
                                                                                                            ),
                                                                                                        );
                                                                                                        setLineLoader(
                                                                                                            el.id,
                                                                                                        );
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={
                                                                                                            refreshIcon
                                                                                                        }
                                                                                                        alt="refershIcon"
                                                                                                        width="15px"
                                                                                                        height="15px"
                                                                                                    />
                                                                                                </span>
                                                                                            )}
                                                                                            {el.isThrottled ? (
                                                                                                <div className="noteDataConsumed">
                                                                                                    <img
                                                                                                        src={
                                                                                                            throttleIcon
                                                                                                        }
                                                                                                        alt="icon"
                                                                                                    />
                                                                                                    Speed throttled down
                                                                                                </div>
                                                                                            ) : (
                                                                                                usedUnits >= 75 && (
                                                                                                    <div className="noteDataConsumed">
                                                                                                        <img
                                                                                                            src={icon}
                                                                                                            alt="icon"
                                                                                                        />
                                                                                                        {usedUnits ===
                                                                                                        100
                                                                                                            ? '100% data consumed'
                                                                                                            : usedUnits >=
                                                                                                              90
                                                                                                            ? 'Over 90% data consumed'
                                                                                                            : 'Over 75% data consumed'}
                                                                                                    </div>
                                                                                                )
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <Skeleton></Skeleton>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="dataUsageError">
                                                                            <img src={lightInfoIcon} alt="icon" />
                                                                            <div className="dataUsageErrorMsg">
                                                                                Failed to load usage history. Kindly
                                                                                refresh the page after some time to try
                                                                                again.
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <span
                                                                        className={
                                                                            el.status === 3 &&
                                                                            !configState?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED || 
                                                                            customerDetails?.meta?.suspended_reason === "NonPay Suspension" ||
                                                                            topupInProgress.includes(el.id) ||
                                                                            isFraudAcc ||
                                                                            simSwapInProgress
                                                                                ? 'addData disableAddData'
                                                                                : 'addData'
                                                                        }
                                                                        onClick={() => {
                                                                            if (
                                                                                el.status === 3 &&
                                                                                !configState?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED || 
                                                                                customerDetails?.meta?.suspended_reason === "NonPay Suspension" ||
                                                                                topupInProgress.includes(el.id) ||
                                                                                isFraudAcc ||
                                                                                simSwapInProgress
                                                                            )
                                                                                return;
                                                                            setUser(el);
                                                                            setIsAddDataJourney(true);
                                                                            setIsAddData(true);
                                                                            let occurence = el.peerAccountRef.split(
                                                                                '|',
                                                                            )[2];
                                                                            TagManager.dataLayer({
                                                                                dataLayer: {
                                                                                    event: 'Add_Data',
                                                                                    accountNo:
                                                                                        customerDetails?.meta
                                                                                            ?.customer_statement_number,
                                                                                    line_number: occurence,
                                                                                },
                                                                            });
                                                                            // GAAndFBEventsHandler("Add_Data", customerDetails?.meta?.customer_statement_number,occurence)
                                                                        }}
                                                                    >
                                                                        <img src={addDataIcon} alt="addDataIcon" />
                                                                        Add Data
                                                                    </span>
                                                                </div>
                                                            ))}
                                                    </div>
                                                    {el.id === viewLineStatus && el.status === 8 && (
                                                        <>
                                                            <div className="HomeBottomLine"></div>
                                                            <div className="BottomDivContent">
                                                                <div className="BottomDivTitle">Activation Failed</div>
                                                                <div className="BottomDivMsg">
                                                                    Sorry, we couldn’t complete line activation for{' '}
                                                                    {(el?.firstName ? returnName(el,"firstName") : '') + ' ' + (el?.lastName ? returnName(el,"lastName") : '')} due to an
                                                                    unexpected error. Please get in touch with our Care
                                                                    Team to resolve this and activate your line.
                                                                </div>
                                                                <div className="BottomDivContact">
                                                                    <img
                                                                        src={phone}
                                                                        alt="phone"
                                                                        width={20}
                                                                        height={20}
                                                                    />
                                                                    Call <span>1.800.427.8686</span> to activate.
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {el.id === viewLineStatus && el.status === 10 && (
                                                        <>
                                                            {portFailedData &&
                                                                portFailedData.map((portFailedCust: any) => {
                                                                    if (portFailedCust.customerId === el.id) {
                                                                        return (
                                                                            <div key={portFailedCust.customerId}>
                                                                                <div className="HomeBottomLine"></div>
                                                                                <div className="BottomDivContent">
                                                                                    <div className="BottomDivTitle">
                                                                                        {portFailedCust?.portFailureCode ===
                                                                                        1009
                                                                                            ? 'Port In Unsuccessful - Incorrect Account   Number'
                                                                                            : portFailedCust?.portFailureCode ===
                                                                                              1010
                                                                                            ? 'Port In Unsuccessful - Incorrect PIN'
                                                                                            : portFailedCust?.portFailureCode ==
                                                                                              1011
                                                                                            ? 'Port In Unsuccessful - Incorrect ZIP Code'
                                                                                            : 'Port In Unsuccessful'}
                                                                                    </div>
                                                                                    <div className="BottomDivMsg">
                                                                                        {portFailedCust?.portFailureCode ===
                                                                                        1009
                                                                                            ? "Your port out request was rejected by your current carrier due to incorrect account number. Please re-enter your correct account number (current carrier's) and submit the request again."
                                                                                            : portFailedCust?.portFailureCode ===
                                                                                              1010
                                                                                            ? 'Your port out request was rejected by your current carrier due to incorrect ZIP code. Please re-enter your correct ZIP code and submit the request again.'
                                                                                            : portFailedCust?.portFailureCode ===
                                                                                              1011
                                                                                            ? 'Your port out request was rejected by your current carrier due to incorrect ZIP code. Please re-enter your correct ZIP code and submit the request again.'
                                                                                            : 'Your port out request was rejected by your current carrier. Please get in touch with our Care Team to resolve this and submit your request again.'}
                                                                                    </div>
                                                                                    <div
                                                                                        className="BottomDivContact"
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            flexDirection: 'column',
                                                                                            alignItems: 'center',
                                                                                            gap: '20px',
                                                                                        }}
                                                                                    >
                                                                                        {(portFailedCust?.portFailureCode ===
                                                                                            1009 ||
                                                                                            portFailedCust?.portFailureCode ===
                                                                                                1010 ||
                                                                                            portFailedCust?.portFailureCode ===
                                                                                                1011) && (
                                                                                            <Button
                                                                                                primary={true}
                                                                                                onClick={() =>
                                                                                                    moveToActivationStatus(
                                                                                                        portFailedCust,
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                Try Again
                                                                                            </Button>
                                                                                        )}
                                                                                        {(portFailedCust?.portFailureCode !==
                                                                                            1009 ||
                                                                                            portFailedCust?.portFailureCode !==
                                                                                                1010 ||
                                                                                            portFailedCust?.portFailureCode !==
                                                                                                1011) && (
                                                                                            <div>
                                                                                                <img
                                                                                                    src={phone}
                                                                                                    alt="phone"
                                                                                                    width={20}
                                                                                                    height={20}
                                                                                                />
                                                                                                Call{' '}
                                                                                                <span>
                                                                                                    1.800.427.8686
                                                                                                </span>{' '}
                                                                                                for assistance.
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    }
                                                                })}
                                                        </>
                                                    )}
                                                    {el.id === viewLineStatus && el.status === 4 && (
                                                        <>
                                                            <div className="HomeBottomLine"></div>
                                                            <div className="BottomDivContent">
                                                                <div className="BottomDivTitle">Line Disconnected</div>
                                                                <div className="BottomDivMsg">
                                                                    {el.lastDisconnectedReason === 0
                                                                        ? 'As requested, your '
                                                                        : 'Your '}
                                                                    line has been disconnected. For any queries or
                                                                    questions please get in touch with our Care Team at{' '}
                                                                    <span>1.800.427.8686</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {el.id === viewLineStatus && el.status === 3 && (
                                                        <>
                                                            <div className="HomeBottomLine"></div>
                                                            <div className="BottomDivContent">
                                                                <div className="BottomDivTitle">Line Suspended</div>
                                                                <div className="BottomDivMsg">
                                                                    Your line has been suspended. For any queries or
                                                                    questions please get in touch with our Care Team at{' '}
                                                                    <span>1.800.427.8686</span>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {!el.simPaid && (
                                                        <>
                                                            <div className="HomeBottomLine"></div>
                                                            <div className="BottomDivContent">
                                                                <div className="BottomDivTitle">
                                                                    Order Placement Underway
                                                                </div>
                                                                <div className="BottomDivMsg">
                                                                    Order processing is taking longer than usual. Please
                                                                    check the order status later. If the issue persists,
                                                                    call us at 1.800.427.8686 for assistance.
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {topupInProgress.includes(el.id) && (
                                                        <>
                                                            <div className="HomeBottomLine"></div>
                                                            <div className="BottomDivContent">
                                                                <div className="BottomDivTitle">
                                                                    Add data request in progress...
                                                                </div>
                                                                <div className="BottomDivMsg">
                                                                    Unfortunately, it is taking a while. The additional
                                                                    data will reflect here shortly.
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            );
                                        })}
                                {customerDetails && customerDetails.status !== 7 && configVals?.ADD_A_LINE === 'ENABLE' && (
                                    <div className="addLineBtn">
                                        <Button
                                            primary={true}
                                            onClick={handleAddLineBtn}
                                            disabled={
                                                isDisabled || 
                                                (customerDetails?.status !== 2 && customerDetails?.status !== 3) &&
                                                !configState?.data?.configs?.ENABLE_LINE_SERVICES_WHEN_PRIMARY_SUSPENEDED ||
                                                customerDetails?.meta?.suspended_reason === "NonPay Suspension" ||
                                                isFraudAcc
                                            }
                                        >
                                            ADD LINE
                                        </Button>
                                    </div>
                                )}
                                {customerDetails.status === 0 && customerDetails.additionalLines > 0 && (
                                    <>
                                        <div className="activateMsgDiv">
                                            <div className="innerDiv">
                                                Please begin by activating {primaryFullName.current}'s line. Once
                                                activated, you can then activate the remaining lines individually.
                                            </div>
                                        </div>
                                        <div className="activateMsgDiv">
                                            <div className="innerDiv">
                                                Need help?{' '}
                                                <span
                                                    className="ct_span mx-2 text-decoration-underline"
                                                    onClick={() => {
                                                        props.history.push({
                                                            pathname: '/help',
                                                        });
                                                    }}
                                                >
                                                    CONTACT US
                                                </span>
                                                <img className="IconMargin" alt="icon" src={contactUs}></img>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
            {isAddDataJourney && (
                <>
                    {!isTopupSuccess && !isTopupFailed && (
                        <div className="addlineBackBtn">
                            <ArrowBackIcon className="arrow_icon" onClick={backHandler} />
                            <div className="addLineTitle">
                                {isAddData ? 'Select Additional Data Volume' : 'Confirm Additional Data Details'}
                            </div>
                        </div>
                    )}
                    {isAddData && (
                        <div className="addDataVol">
                            <div className="lineUserName">
                                Line: <span className="username">{user?.firstName ? user.firstName : '' + ' ' + user?.lastName ? user.lastName : ''}</span>
                            </div>
                            <div className="addLineData">
                                <div className="dataTopUp">
                                    <TextField value={`${dataTopup} GB`} type={'text'} disabled />
                                    <img
                                        src={incrementIcon}
                                        alt="incrementIcon"
                                        className="incrementIcon"
                                        onClick={() => handleDataTopup('increment')}
                                    />
                                    <img
                                        src={decrementIcon}
                                        alt="incrementIcon"
                                        className="decrementIcon"
                                        onClick={() => handleDataTopup('decrement')}
                                    />
                                </div>
                                {configVals && (
                                    <div className="maxData">
                                        (Max. {configVals && configVals?.TOPUP_DATA_LIMIT} GB)
                                    </div>
                                )}
                            </div>
                            <div className="addLineCharges">
                                {dataTopupCharges && (
                                    <div className="charges">Charges: ${dataTopupCharges.toFixed(2)}</div>
                                )}
                                {topupPulseDetails && (
                                    <div className="chargesInfo">
                                        (${parseFloat(topupPulseDetails?.pulseCost).toFixed(2)}/
                                        {topupPulseDetails?.pulse} GB)
                                    </div>
                                )}
                            </div>
                            <div className="proceedlineBtn">
                                <Button primary={true} disabled={creditLimitError} onClick={() => handleAddData()}>
                                    PROCEED
                                </Button>
                            </div>
                            {creditLimitError && (
                                <div className="errortopup">
                                    <div className="errorTitle">Let's Talk</div>
                                    <div className="errorMsg">
                                        We're sorry. The service you're attempting to access or update is temporarily
                                        unavailable.
                                    </div>
                                    <div className="errorContact">
                                        Please contact us at <span>1.800.427.8686</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {isDataProceed && (
                        <div className="addDataVol">
                            <div className="lineUserName">
                                Line: <span className="username">{user?.firstName ? user.firstName : '' + ' ' + user?.lastName ? user.lastName : ''}</span>
                            </div>
                            <div className="orderSummary">
                                <div className="summary">
                                    <div className="planInfo">
                                        <div className="planName">{`${dataTopup} GB ($${parseFloat(
                                            topupPulseDetails?.pulseCost,
                                        ).toFixed(2)}/${topupPulseDetails?.pulse} GB)`}</div>
                                        {/* (${parseFloat(topupPulseDetails?.pulseCost).toFixed(2)}/
                                        {topupPulseDetails?.pulse} GB) */}
                                        <div className="planPrice">${dataTopupCharges.toFixed(2)}</div>
                                    </div>
                                    <div className="note">({step3?.orderSummaryModal?.subtext})</div>
                                    <div className="line"></div>
                                    <div className="info">{step3?.orderSummaryModal?.note}</div>
                                    <div
                                        className="terms"
                                        onClick={() => {
                                            window.open(process.env.REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL);
                                        }}
                                    >
                                        TERMS & CONDITIONS
                                    </div>
                                </div>
                                <div className="summaryConfirmBtn">
                                    <Button primary={true} onClick={() => !isBuyDataClicked && callTopupApi()}>
                                        {isBuyDataClicked ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            'CONFIRM'
                                        )}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                    {isTopupSuccess && (
                        <div className="topupSucess">
                            <img src={successIcon} alt="successIcon" />
                            <div className="lineUserData">{dataTopup} GB Additional Data Purchased!</div>
                            <div className="lineUserName topupLine">
                                Line: <span className="username">{user?.firstName ? user.firstName : '' + ' ' + user?.lastName ? user.lastName : ''}</span>
                            </div>
                            <div className="summaryConfirmBtn">
                                <Button primary={true} onClick={() => handleTopupSuccess()}>
                                    CONTINUE
                                </Button>
                            </div>
                        </div>
                    )}
                    {isTopupFailed && (
                        <div className="topupSucess">
                            <img src={failedIcon} alt="successIcon" />
                            <div className="lineUserData">Data Addition Failed</div>
                            <div className="topupFailedMsg">
                                Sorry, your request for additional data could not be completed due <br />
                                to an unexpected error.
                            </div>
                            <div className="summaryConfirmBtn">
                                <Button
                                    primary={true}
                                    onClick={() => {
                                        setIsTopupFailed(false);
                                        setIsAddData(true);
                                    }}
                                >
                                    TRY AGAIN
                                </Button>
                            </div>
                        </div>
                    )}
                </>
            )}
            {isAddLineJourney && (
                <>
                    {!isLineAdded && !isInvalidImei && (
                        <div className="addlineBackBtn">
                            {!isShipmentFailed && (
                                <img
                                    src={backArrow}
                                    alt="backArrow"
                                    className="arrow_icon"
                                    onClick={addLineBackHandler}
                                />
                            )}
                            <div className="addLineTitle">
                                {isChangeAddress
                                    ? 'Enter Shipping Address'
                                    : isAddLineCharges
                                    ? 'Additional Line Charges'
                                    : isAddLineSummary
                                    ? 'Add Line Summary'
                                    : isShipmentFailed
                                    ? ''
                                    : 'Add a New Line'}
                            </div>
                        </div>
                    )}
                    {isLineAdded ? (
                        <AddLineSuccess
                            history={props.history}
                            deviceDetails={deviceDetails}
                            setIsImeiData={setIsImeiData}
                            setIsAddLineJourney={setIsAddLineJourney}
                        />
                    ) : isAddLineCharges ? (
                        <OneTimeCharge
                            history={props.history}
                            setIsChangeAddress={setIsChangeAddress}
                            deviceDetails={deviceDetails}
                            setIsLineAdded={setIsLineAdded}
                            setIsShipmentFailed={setIsShipmentFailed}
                            setIsAddLineSummary={setIsAddLineSummary}
                            setIsAddLineCharges={setIsAddLineCharges}
                        />
                    ) : isAddLineSummary ? (
                        <AddLineSummary
                            history={props.history}
                            deviceDetails={deviceDetails}
                            setIsAddLineCharges={setIsAddLineCharges}
                            setIsLineAdded={setIsLineAdded}
                            setIsShipmentFailed={setIsShipmentFailed}
                            setIsAddLineSummary={setIsAddLineSummary}
                            // ---- HSD Changes ------
                            primaryHsdDiscount={primaryHsdDiscount}
                            secHsdDiscount={secHsdDiscount}
                            isHsdCustomer={isHsdCustomer}
                        />
                    ) : isShipmentFailed ? (
                        <MessageComponent backToHomeHandler={backShippingFailed} />
                    ) : (
                        <VerifyDevice
                            history={props.history}
                            setIsAddLineSummary={setIsAddLineSummary}
                            deviceDetails={deviceDetails}
                            setDeviceDetails={setDeviceDetails}
                            setIsImeiData={setIsImeiData}
                            isImeiData={isImeiData}
                            isInvalidImei={isInvalidImei}
                            setIsInvalidImei={setIsInvalidImei}
                        />
                    )}
                </>
            )}
            {isEditName && (
                <AddLineUserDetails
                    history={props.history}
                    userData={editUser}
                    isEditName={isEditName}
                    setIsEditName={setIsEditName}
                />
            )}
            <Footer isFixed={true} />
        </div>
    );
};

export default AstoundHome;
